export default "__VITE_ASSET__BkPPFspM__"